shadow$provide[491] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, hash:{enumerable:true, get:function() {
  return hash;
}}});
const c1 = 3432918353;
const c2 = 461845907;
const c3 = 3864292196;
const c4 = 2246822507;
const c5 = 3266489909;
let imul = function(a, b) {
  const ah = a >>> 16 & 65535;
  const al = a & 65535;
  const bh = b >>> 16 & 65535;
  const bl = b & 65535;
  return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
};
if (Math.imul != null) {
  const test = Math.imul(4294967295, 5);
  if (test === -5) {
    ({imul} = Math);
  }
}
const hash = function(string) {
  let h;
  const n = string.length;
  let m = Math.floor(n / 2);
  let j = h = 0;
  const next = () => string.charCodeAt(j++);
  const iterate = function(a, b) {
    let k = a | b << 16;
    k ^= k << 9;
    k = imul(k, c1);
    k = k << 15 | k >>> 17;
    k = imul(k, c2);
    h ^= k;
    h = h << 13 | h >>> 19;
    h = imul(h, 5);
    return h = h + c3 | 0;
  };
  while (m--) {
    iterate(next(), next());
  }
  if (n & 1) {
    iterate(next(), 0);
  }
  h ^= n;
  h ^= h >>> 16;
  h = imul(h, c4);
  h ^= h >>> 13;
  h = imul(h, c5);
  return h ^= h >>> 16;
};

};